import {AfterViewInit, Component, OnInit} from '@angular/core';
import {language} from '../../../../language/vn';
import { ToastrService } from 'ngx-toastr';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {Subject} from 'rxjs';
import {GroupSelectComponent} from '../../group/groupselect.component';
import {CommandUtil} from '../../../../global/commandutil';
import {VanBanDenXLService} from '../../../../service/vanbanden/service-vanbandenxl';
import {VanBanDenXL} from '../../../../models/vanbanden/vanbandenxl';
import {ConfirmDialogComponent} from '../../../dialog/confirmdialog.component';
import {VanBanDiXLService} from '../../../../service/vanbandi/service-vanbandixl';
import {VanBanDiXL} from '../../../../models/vanbandi/vanbandixl';
@Component({
  templateUrl: './destroy.component.html'
})
export class DestroyVanBanDiXuLyComponent implements OnInit, AfterViewInit {
  public language = language;
  public id: number = 0;
  public onClose: Subject<boolean>;
  public dataList: VanBanDiXL[] = [];
  public checked: boolean = false;
  public dataCheck: Object[]=[];
  constructor(
    public toastr: ToastrService,
    public bsModalService: BsModalService,
    public _bsModalRef: BsModalRef,
    public commandUtils: CommandUtil,
    public vanBanDiXuLyService: VanBanDiXLService

  ) {
  }
  ngAfterViewInit() {
  }
  toggleDropdown($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();
  }
  public edit(id: number) {
    this.id= id;
    this.loadData();
  }
  public loadData()
  {
    this.vanBanDiXuLyService.getAllByMaVB(this.id).subscribe(data => {
      this.dataList = data;
    });
  }
  public checkAll(event)
  {
    this.dataCheck=[];
    this.checked= event.target.checked;
    if(event.target.checked == true)
    {
      for(let i=0;i< this.dataList.length;i++)
        this.dataCheck.push(this.dataList[i].id);
    }
  }
  public checkedItem(event)
  {

    if(event.target.checked== true && this.dataCheck.indexOf(event.target.value) ==-1)
      this.dataCheck.push(event.target.value);
    else
      this.dataCheck.splice(this.dataCheck.indexOf(event.target.value),1);
    if(this.dataCheck.length==0)
      this.checked=false;
  }
  public detroyXuLy(id: number): void {

    const modal = this.bsModalService.show(ConfirmDialogComponent);
    (<ConfirmDialogComponent>modal.content).showConfirmationModal(
      language.message,
      language.confirm_destroy_xuly,
      language.yes,
      language.no
    );
    (<ConfirmDialogComponent>modal.content).onClose.subscribe(result => {
      if (result === true) {
        this.vanBanDiXuLyService.delete(id).subscribe(
          {next: () => {
              this.toastr.success(language.message_destroy_xuly_success, language.message);
              this.loadData();
            },
            error: error => {
              this.toastr.error(language.error, language.message);
            }
          });
      }
    });
  }
  public detroyXuLyMulti(): void {

    const modal = this.bsModalService.show(ConfirmDialogComponent);
    (<ConfirmDialogComponent>modal.content).showConfirmationModal(
      language.message,
      language.confirm_destroy_xuly,
      language.yes,
      language.no
    );
    (<ConfirmDialogComponent>modal.content).onClose.subscribe(result => {
      if (result === true) {
        this.vanBanDiXuLyService.deleteMulti(this.id, this.dataCheck.join(',')).subscribe(
          {next: () => {
              this.toastr.success(language.message_destroy_xuly_success, language.message);
              this.loadData();
              this.dataCheck = [];
              this.checked = false;
            },
            error: error => {
              this.toastr.error(language.error, language.message);
            }
          });
      }
    });
  }
  ngOnInit(): void {
    this.onClose = new Subject();
  }
  public onSave(): void {
    if(this.dataCheck.length > 0)
      this.detroyXuLyMulti();
    else
      this.toastr.warning(language.confirm_destroy_select, language.message);

  }
  public onCancel(): void {
    this.onClose.next(true);
    this._bsModalRef.hide();
  }
  public hideConfirmationModal(): void {
    this.onClose.next(null);
    this._bsModalRef.hide();
  }
}

